@if (!user()) {
  <app-header [user]="user()" />
}

<section class="www-pro-edu-tra">
  @if (eventDetails()) {
    <app-pro-edu-tra-top [trainingDetails]="eventDetails()" />
    <!-- <app-pro-edu-tra-info [trainingDetails]="eventDetails()" /> -->
    <!-- <app-pro-exp-con-txt /> -->
    <app-pro-exp-con-red-txt [trainingDetails]="eventDetails()" />
    <!-- <app-pro-exp-tra-des [trainingDetails]="eventDetails()" /> -->
    @if (eventDetails()?.slug === 'sniadanie-networkingowe') {
      <app-pro-exp-experts-slider />
    }
    <app-pro-edu-tra-tic [trainingDetails]="eventDetails()!" />
  }
  <!-- <app-gallery /> -->
  <!-- <app-newsletter-section /> -->
</section>
